import React from 'react';
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { DropdownItemProps } from 'react-bootstrap/esm/DropdownItem';
import { Placement } from 'react-bootstrap/types';

type DropdownActionItemProps = {
  size?: 'sm';
  tooltip?: string;
  tooltipPlacement?: Placement;
  tooltipId?: string;
} & DropdownItemProps;

export const DropdownActionItem: React.FC<DropdownActionItemProps> = ({
  children,
  size,
  className,
  onClick,
  tooltip,
  tooltipPlacement = 'top',
  tooltipId,
  ...props
}) => {
  const classNames = [
    'd-flex align-items-center',
    className,
    size === 'sm' ? 'small px-3 py-1' : undefined,
  ].join(' ');

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    onClick && onClick(e);
  };

  const dropdownItem = (
    <Dropdown.Item
      {...props}
      as="button"
      className={classNames}
      onClick={handleClick}>
      {children}
    </Dropdown.Item>
  );

  if (tooltip) {
    return (
      <OverlayTrigger
        overlay={
          <Tooltip
            id={tooltipId || `dropdown-action-item-tooltip-${Math.random()}`}>
            {tooltip}
          </Tooltip>
        }
        placement={tooltipPlacement}>
        <span>{dropdownItem}</span>
      </OverlayTrigger>
    );
  }

  return dropdownItem;
};
